import {
  Send,
  Menu,
  BriefcaseBusiness,
  FileText,
  Ticket,
  UserPlus,
  TabletSmartphone,
  ScanLine,
  LogOut,
  BellRing,
  Video,
  Monitor,
  Car 
} from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { cn } from "src/lib/utils";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { disconnect } from "src/helpers/localStorage";
import { useTranslation } from "../../pages";



export const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [monitorOpen, setMonitorOpen] = useState(false);
  const [rapportOpen, setRapportOpen] = useState(false);
  const [businessOpen, setBusinessOpen] = useState(false);
  const [dashboardMenuStyle, setDashboardMenuStyle] = useState(null);
  const [monitorMenuStyle, setMonitorMenuStyle] = useState(null);
  const [rapportMenuStyle, setRapportMenuStyle] = useState(null);
  const [businessMenuStyle, setBusinessMenuStyle] = useState(null);
  const dashboardButtonRef = useRef(null);
  const monitorButtonRef = useRef(null);
  const rapportButtonRef = useRef(null);
  const businessButtonRef = useRef(null);
  const location = useLocation();
  const { t } = useTranslation();
  const onLogOut = () => {
    disconnect();
    window.location.reload();
  };
  const navItems = [
    { icon: Send, label: "Suivi des vehicules", path: "/my-data/tracking" },
    //{ icon: Car, label: "Vehicules", path: "/my-data/my-vehicles" },
    { icon: Monitor, label: "Ymane", path: "/my-data/ymane-lewoo" },
    //{ icon: Building2, label: t("sidebar.places"), path: "/my-data/places" },
    //{ icon: Road, label: t("sidebar.routes"), path: "/my-data/routes" },
    //{ icon: Monitor, label: "Monitor", path: "/my-data/monitor-page" },
    //{ icon: CreditCard, label: "License", path: "/my-data/reports" },
  ];


  const dashboardItems = [
    { icon: BriefcaseBusiness, label: "Dashboard", path: "/my-data/dashboard" },
    { icon: BriefcaseBusiness, label: "Dashboard operation", path: "/my-data/fleet-operation" },
    { icon: UserPlus, label: "DIagnostic and monitoring manager", path: "/my-data/monitoring-manager" },
  ];
  const isDashboardActive = dashboardItems.some((item) => location.pathname === item.path);


  const monitorItems = [
    { icon: Monitor, label: "Monitor", path: "/my-data/dashcam/configuration" },
    { icon: BellRing, label:"Event Center", path: "/my-data/event-center" },
    { icon: Video, label: "Dashcam", path: "/my-data/dashcam" },
  ];
  const isMonitorActive = monitorItems.some((item) => location.pathname === item.path);

  
  const rapportItems = [
    { icon: FileText, label: "Rapports & Analytique", path: "/my-data/reports" },
    { icon: FileText, label: "Nouveaux rapports", path: "/my-data/new-reports" },
  ];
  const isRapportActive = rapportItems.some((item) => location.pathname === item.path);

  const supportTicketItem = {
    icon: Ticket,
    label: "Support Ticket",
    path: "/my-data/support-ticket",
  };
  const isSupportTicketActive = location.pathname === supportTicketItem.path;

  const businessItems = [
    { icon: BriefcaseBusiness, label: "Business Profile", path: "/my-data/business" },
    { icon: UserPlus, label: "Fleet Manager", path: "/my-data/business/add-user" },
    { icon: TabletSmartphone, label: "Units", path: "/my-data/business/units" },
    { icon: ScanLine, label: "Add Device", path: "/my-data/business/change-imei" },
  ];
  const isBusinessActive = businessItems.some((item) => location.pathname === item.path);

  const buildOverlayStyle = (buttonRef, minWidth = 220) => {
    const element = buttonRef.current;
    if (!element) return null;

    const rect = element.getBoundingClientRect();
    const top = Math.max(12, rect.top + rect.height / 2);

    return {
      position: "fixed",
      left: rect.right + 12,
      top,
      transform: "translateY(-50%)",
      minWidth,
      zIndex: 9999,
    };
  };

  useEffect(() => {
    const syncOverlayPositions = () => {
      if (dashboardOpen) {
        setDashboardMenuStyle(buildOverlayStyle(dashboardButtonRef, 220));
      }
      if (monitorOpen) {
        setMonitorMenuStyle(buildOverlayStyle(monitorButtonRef, 220));
      }
      if (rapportOpen) {
        setRapportMenuStyle(buildOverlayStyle(rapportButtonRef, 220));
      }
      if (businessOpen) {
        setBusinessMenuStyle(buildOverlayStyle(businessButtonRef, 180));
      }
    };

    syncOverlayPositions();
    window.addEventListener("resize", syncOverlayPositions);
    window.addEventListener("scroll", syncOverlayPositions, true);

    return () => {
      window.removeEventListener("resize", syncOverlayPositions);
      window.removeEventListener("scroll", syncOverlayPositions, true);
    };
  }, [dashboardOpen, monitorOpen, rapportOpen, businessOpen]);

  useEffect(() => {
    setDashboardOpen(false);
    setMonitorOpen(false);
    setRapportOpen(false);
    setBusinessOpen(false);
  }, [location.pathname]);

  return (
    <aside
      className={cn(
        "relative z-40 flex h-screen shrink-0 flex-col overflow-visible bg-[#313131] text-[#cbd5e1] transition-all duration-200",
        collapsed ? "w-20" : "w-[80px]"
      )}
    >
      <div className="flex h-[50px] items-center justify-center bg-[#10b981] px-2">
        <img
          src={logo}
          alt="Logo"
          className={cn("object-contain", collapsed ? "h-full w-full" : "h-full w-full ")}
        />
      </div>
    


      <nav className="relative z-40 min-h-0 flex-1 overflow-y-auto py-2">
        <div className="relative overflow-visible">
          <button
            ref={dashboardButtonRef}
            type="button"
            onClick={() => setDashboardOpen((prev) => !prev)}
            className={cn(
              "relative flex w-full flex-col items-center gap-2 px-2 py-4 text-center transition-colors duration-200",
              isDashboardActive || dashboardOpen
                ? "bg-[#191c1f] text-white"
                : "text-[#aeb9c5] hover:bg-[#383838] hover:text-white"
            )}
          >
            {isDashboardActive || dashboardOpen ? (
              <span className="absolute left-0 top-0 h-full w-[3px] bg-[#10b981]" />
            ) : null}
            <span className="grid h-7 w-7 place-items-center text-[#e5e7eb]">
              <BriefcaseBusiness className="h-5 w-5 shrink-0" />
            </span>
            {!collapsed ? <span className="text-[11px] font-semibold leading-tight text-white">Dashboard</span> : null}
          </button>

          {dashboardOpen ? (
            <div
              style={dashboardMenuStyle || undefined}
              className="overflow-hidden rounded-r-md rounded-tl-md border border-[#41484d] bg-[#2d3439] py-2 shadow-2xl"
            >
              {dashboardItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setDashboardOpen(false)}
                    className={cn(
                      "flex items-center gap-3 px-4 py-3 text-sm transition-colors duration-200",
                      isActive
                        ? "bg-[#364047] text-white"
                        : "text-[#c3ccd5] hover:bg-[#364047] hover:text-white"
                    )}
                  >
                    <item.icon className="h-4 w-4 shrink-0" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          ) : null}
        </div>

        {navItems.slice(0, 1).map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={index}
              to={item.path}
              className={cn(
                "relative flex w-full flex-col items-center gap-2 px-2 py-4 text-center transition-colors duration-200",
                isActive
                  ? "bg-[#191c1f] text-white"
                  : "text-[#aeb9c5] hover:bg-[#383838] hover:text-white"
              )}
            >
              {isActive ? <span className="absolute left-0 top-0 h-full w-[3px] bg-[#10b981]" /> : null}
              <span className="grid h-7 w-7 place-items-center text-[#e5e7eb]">
                <item.icon className="h-5 w-5 shrink-0" />
              </span>
              {!collapsed ? (
                <span className={cn("text-[11px] leading-tight", isActive ? "font-semibold text-white" : "font-normal")}>
                  {item.label}
                </span>
              ) : null}
            </Link>
          );
        })}

        <div className="relative overflow-visible">
          <button
            ref={monitorButtonRef}
            type="button"
            onClick={() => setMonitorOpen((prev) => !prev)}
            className={cn(
              "relative flex w-full flex-col items-center gap-2 px-2 py-4 text-center transition-colors duration-200",
              isMonitorActive || monitorOpen
                ? "bg-[#191c1f] text-white"
                : "text-[#aeb9c5] hover:bg-[#383838] hover:text-white"
            )}
          >
            {isMonitorActive || monitorOpen ? (
              <span className="absolute left-0 top-0 h-full w-[3px] bg-[#10b981]" />
            ) : null}
            <span className="grid h-7 w-7 place-items-center text-[#e5e7eb]">
              <Monitor className="h-5 w-5 shrink-0" />
            </span>
            {!collapsed ? <span className="text-[11px] font-semibold leading-tight text-white">Monitor</span> : null}
          </button>

          {monitorOpen ? (
            <div
              style={monitorMenuStyle || undefined}
              className="overflow-hidden rounded-r-md rounded-tl-md border border-[#41484d] bg-[#2d3439] py-2 shadow-2xl"
            >
              {monitorItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setMonitorOpen(false)}
                    className={cn(
                      "flex items-center gap-3 px-4 py-3 text-sm transition-colors duration-200",
                      isActive
                        ? "bg-[#364047] text-white"
                        : "text-[#c3ccd5] hover:bg-[#364047] hover:text-white"
                    )}
                  >
                    <item.icon className="h-4 w-4 shrink-0" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          ) : null}
        </div>

        {navItems.slice(1).map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "relative flex w-full flex-col items-center gap-2 px-2 py-4 text-center transition-colors duration-200",
                isActive
                  ? "bg-[#191c1f] text-white"
                  : "text-[#aeb9c5] hover:bg-[#383838] hover:text-white"
              )}
            >
              {isActive ? <span className="absolute left-0 top-0 h-full w-[3px] bg-[#10b981]" /> : null}
              <span className="grid h-7 w-7 place-items-center text-[#e5e7eb]">
                <item.icon className="h-5 w-5 shrink-0" />
              </span>
              {!collapsed ? (
                <span className={cn("text-[11px] leading-tight", isActive ? "font-semibold text-white" : "font-normal")}>
                  {item.label}
                </span>
              ) : null}
            </Link>
          );
        })}

        <div className="relative overflow-visible">
          <button
            ref={rapportButtonRef}
            type="button"
            onClick={() => setRapportOpen((prev) => !prev)}
            className={cn(
              "relative flex w-full flex-col items-center gap-2 px-2 py-4 text-center transition-colors duration-200",
              isRapportActive || rapportOpen
                ? "bg-[#191c1f] text-white"
                : "text-[#aeb9c5] hover:bg-[#383838] hover:text-white"
            )}
          >
            {isRapportActive || rapportOpen ? (
              <span className="absolute left-0 top-0 h-full w-[3px] bg-[#10b981]" />
            ) : null}
            <span className="grid h-7 w-7 place-items-center text-[#e5e7eb]">
              <FileText className="h-5 w-5 shrink-0" />
            </span>
            {!collapsed ? <span className="text-[11px] font-semibold leading-tight text-white">Rapport</span> : null}
          </button>

          {rapportOpen ? (
            <div
              style={rapportMenuStyle || undefined}
              className="overflow-hidden rounded-r-md rounded-tl-md border border-[#41484d] bg-[#2d3439] py-2 shadow-2xl"
            >
              {rapportItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setRapportOpen(false)}
                    className={cn(
                      "flex items-center gap-3 px-4 py-3 text-sm transition-colors duration-200",
                      isActive
                        ? "bg-[#364047] text-white"
                        : "text-[#c3ccd5] hover:bg-[#364047] hover:text-white"
                    )}
                  >
                    <item.icon className="h-4 w-4 shrink-0" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          ) : null}
        </div>

        <div className="relative overflow-visible">
          <Link
            to={supportTicketItem.path}
            className={cn(
              "relative flex w-full flex-col items-center gap-2 px-2 py-4 text-center transition-colors duration-200",
              isSupportTicketActive
                ? "bg-[#191c1f] text-white"
                : "text-[#aeb9c5] hover:bg-[#383838] hover:text-white"
            )}
          >
            {isSupportTicketActive ? (
              <span className="absolute left-0 top-0 h-full w-[3px] bg-[#10b981]" />
            ) : null}
            <span className="grid h-7 w-7 place-items-center text-[#e5e7eb]">
              <supportTicketItem.icon className="h-5 w-5 shrink-0" />
            </span>
            {!collapsed ? (
              <span className={cn("text-[11px] leading-tight", isSupportTicketActive ? "font-semibold text-white" : "font-normal")}>
                {supportTicketItem.label}
              </span>
            ) : null}
          </Link>
        </div>

        <div className="relative overflow-visible">
          <button
            ref={businessButtonRef}
            type="button"
            onClick={() => setBusinessOpen((prev) => !prev)}
            className={cn(
              "relative flex w-full flex-col items-center gap-2 px-2 py-4 text-center transition-colors duration-200",
              isBusinessActive || businessOpen
                ? "bg-[#191c1f] text-white"
                : "text-[#aeb9c5] hover:bg-[#383838] hover:text-white"
            )}
          >
            {isBusinessActive || businessOpen ? (
              <span className="absolute left-0 top-0 h-full w-[3px] bg-[#10b981]" />
            ) : null}
            <span className="grid h-7 w-7 place-items-center text-[#e5e7eb]">
              <BriefcaseBusiness className="h-5 w-5 shrink-0" />
            </span>
            {!collapsed ? <span className="text-[11px] font-semibold leading-tight text-white">Business</span> : null}
          </button>

          {businessOpen ? (
            <div
              style={businessMenuStyle || undefined}
              className="overflow-hidden rounded-r-md rounded-tl-md border border-[#41484d] bg-[#2d3439] py-2 shadow-2xl"
            >
              {businessItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setBusinessOpen(false)}
                    className={cn(
                      "flex items-center gap-3 px-4 py-3 text-sm transition-colors duration-200",
                      isActive
                        ? "bg-[#364047] text-white"
                        : "text-[#c3ccd5] hover:bg-[#364047] hover:text-white"
                    )}
                  >
                    <item.icon className="h-4 w-4 shrink-0" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          ) : null}
        </div>
      </nav>

      <div className="border-t border-[#8a8a8a] p-2">
        <button
          type="button"
          onClick={onLogOut}
          className="mb-1 flex w-full flex-col items-center justify-center gap-2 py-3 text-[#e5e7eb] hover:bg-[#383838]"
          aria-label={t("sidebar.logout")}
        >
          <LogOut className="h-5 w-5 rotate-45" />
          {!collapsed ? <span className="text-[11px] leading-tight">{t("sidebar.logout")}</span> : null}
        </button>
        
      </div>
      <div className="border-t border-[#8a8a8a] p-2">
       
        <button
          type="button"
          className="flex w-full items-center justify-center py-3 text-[#e5e7eb] hover:bg-[#383838]"
          aria-label={collapsed ? t("sidebar.menu.open") : t("sidebar.menu.close")}
          onClick={() => setCollapsed((prev) => !prev)}
        >
          <Menu className="h-5 w-5" />
        </button>
      </div>
    </aside>
  );
};
